module.exports = __webpack_public_path__ + "static/media/logo_xicaes.7cbf279b.webp";